import { downloadDocuments } from '../../../lib/utils/files/download-documents'
import { API, constructApiUrl } from '../../apis.config'
import { EndOfJourneyReviewsSummaryRequest } from './types'

/** "Export excel": the summary as displayed, for the ticked rows if any. */
export function exportEndOfJourneyReviewsSummary(input: EndOfJourneyReviewsSummaryRequest) {
  return downloadDocuments<EndOfJourneyReviewsSummaryRequest>({
    endpoint: constructApiUrl(API['end-of-journey-reviews-summary'].exportExcel.url, null),
    data: input
  })
}
